import React, { useState, useEffect } from "react";
import { Button } from "react-materialize";
import $ from "jquery";
import config from "../../config";
import API from "../../utils/API";
import Handle from "../Container/modal.handle";
import ModalDone from "../Container/modal.done";
import ModalError from "../Container/modal.error";
import ModalWarning from "../Container/modal.warning";

export default function BtnEditSubmit({ events, header }) {
  const [resData, setResData] = useState({ status: "", err: 0, err_msg: "" });
  const callbackEvent = {
    OnClose: function () {
      setResData({ status: "", err: 0, err_msg: "" });
    },
    OnComplete: function () {
      events.OnComplete();
    } };
  const handleEvents = {
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setResData({ status: "", err: 0, err_msg: "" });
    },
    OnSubmit: function () {
      Handle.loading.OnShow();
      let elemForm = document.getElementById("form-edit-request");
      let formData = new FormData(elemForm);

      // formData.append("starttime", $("input[name='starttime']").val());

      // Function to check if a key exists in FormData
      function hasKey(formData, key) {
        for (let [formKey] of formData.entries()) {
          if (formKey === key) {
            return true;
          }
        }
        return false;
      }

      // Check and append values only if missing
      let enddateValue = $("input[name='enddate']").val();
      let endtimeValue = $("input[name='endtime']").val();

      if (!hasKey(formData, "enddate") && enddateValue) {
        formData.append("enddate", enddateValue);
      }

      if (!hasKey(formData, "endtime") && endtimeValue) {
        formData.append("endtime", endtimeValue);
      }

      // Always append userID
      formData.append("userID", window.$user_profile.idu);

      // // Debugging: Log final formData
      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }

      const mainFunc = async () =>
        await API.post("hr/request/edit/submit", formData);
      mainFunc()
        .then((res) => {
          Handle.loading.OnHide();
          const decrypt = (res?.data);
          // console.log("response=", decrypt);
          if (decrypt?.status === "success") {
            setResData(decrypt);
          } else {
            setResData({
              err: 1,
              err_msg: `Failes : ` + decrypt?.err_msg ?? "" });
          }
        })
        .catch((err) => {
          Handle.loading.OnHide();
          setResData({ err: 1, err_msg: "" });
        });
    } };
  //console.log("Edit Submit", resData);
  if ("err" in resData && resData.err === 1) {
    return (
      <ModalWarning
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if ("err" in resData && resData.err === 2) {
    return (
      <ModalError
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if (resData.status === "success") {
    return (
      <ModalDone
        header={header}
        content="This update is done!"
        callbackEvent={callbackEvent}
      />
    );
  }
  return (
    <Button
      className=""
      id="btn-submit-edit"
      node="button"
      waves="light"
      onClick={handleEvents.OnSubmit}
    >
      Update
    </Button>
  );
}


